import { render, staticRenderFns } from "./PoliceMap.vue?vue&type=template&id=5fa01c7f&scoped=true&"
import script from "./PoliceMap.vue?vue&type=script&lang=js&"
export * from "./PoliceMap.vue?vue&type=script&lang=js&"
import style0 from "./PoliceMap.vue?vue&type=style&index=0&id=5fa01c7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa01c7f",
  null
  
)

export default component.exports